import { createActionGroup, props } from '@ngrx/store';
import { Section } from './model/directory.model';

export const DirectoryTemplateActions = createActionGroup({
  source: 'Directory Template',
  events: {
    'Set Sections': props<{ sections: Section[] }>(),
  },
});

export const DirectoryAPIActions = createActionGroup({
  source: 'Directory API',
  events: {
    'Load Sections': props<{ apiUrl: string }>(),
    'Sections Loaded Success': props<{ sections: Section[] }>(),
    'Sections Loaded Fail': props<{ message: string }>(),
  },
});
